export default function TwoToneHeading({
  id,
  title,
  subtitle,
  as: Heading = "h2",
  sizeClassName = "text-[2rem] sm:text-[2.75rem]",
}: {
  id: string;
  title: string;
  subtitle: string;
  as?: "h1" | "h2";
  sizeClassName?: string;
}) {
  return (
    <Heading
      id={id}
      className={`max-w-[52rem] font-semibold leading-[1.1] tracking-[-0.03em] text-foreground ${sizeClassName}`}
    >
      {title}{" "}
      <span className="text-[#6E6E73] dark:text-zinc-400">{subtitle}</span>
    </Heading>
  );
}
